import { useMutation } from '@tanstack/react-query';

import {
  createSystemAdmin,
  createSystemAdminValidation,
  revokeSystemAdmin,
  revokeSystemAdminValidation,
} from '../../api/endpoints/admin';
import { IFormErrorResponse } from '../../api/interfaces';

export const useCreateAdmin = () => {
  const { mutateAsync: createAdmin } = useMutation<
    undefined,
    IFormErrorResponse,
    string
  >({
    mutationFn: (email) => createSystemAdmin(email),
  });

  const { mutateAsync: validateEmail, isPending: isLoading } = useMutation<
    undefined,
    IFormErrorResponse,
    string
  >({
    mutationFn: (email) => createSystemAdminValidation(email),
  });

  return {
    validateEmail,
    createAdmin,
    isLoading,
  };
};

export const useDeleteAdmin = () => {
  const { mutateAsync: deleteAdmin } = useMutation<
    any,
    IFormErrorResponse,
    string
  >({
    mutationFn: (email) => revokeSystemAdmin(email),
  });

  const { mutateAsync: validateEmail, isPending: isLoading } = useMutation<
    any,
    IFormErrorResponse,
    string
  >({
    mutationFn: (email) => revokeSystemAdminValidation(email),
  });

  return { validateEmail, deleteAdmin, isLoading };
};
